<template>
    <div class="q-pa-md" id="Schemes" style="padding-top: 100px">
        <q-tabs align="left" class="text-primary" style="padding-left: 16px;padding-right: 16px" v-model="tab">
            <q-tab :label="'Joined ('+jointSchemes.length+')'" class="text-green" name="joint"></q-tab>
            <q-tab :label="'Eligible ('+eligibleSchemes.length+')'" class="text-deep-orangec" name="eligible"></q-tab>
        </q-tabs>
        <q-separator></q-separator>

        <q-tab-panels animated v-model="tab">
            <q-tab-panel name="joint">
                <div class="row " v-if="jointSchemes.length">

                    <div class="col-4 q-pa-md " v-for="scheme in jointSchemes">
                        <div class="card-bg">
                            <q-img :src="constants.base_url+scheme.backgroundImage" style="height: 100%;"></q-img>

                            <div class="card-details p-3">
                                <div class="position-relative" style="height: 100%;">
                                    <div class="card-content">
                                        <h5>{{scheme.name}}</h5>
                                    </div>

                                    <div class="mt-3 w-100" style="align-items: center; ">
                                        <div class="w-100 p-2 d-flex justify-content-between">

                                            <div>
                                                <div class="pr-2 ">
                                                    <label class="bankLabel" style="color: #d4d4d4;">From</label>
                                                    <span class="d-block"
                                                          style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{scheme.startTime|dateFilter}}</span>
                                                </div>
                                                <div class="pt-3">
                                                    <label class="bankLabel" style="color: #d4d4d4;">To</label>
                                                    <span class="d-block"
                                                          style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{scheme.endTime|dateFilter}}</span>
                                                </div>
                                            </div>

                                            <div>
                                                <div class="pt-0">
                                                    <label class="bankLabel" style="color: #d4d4d4;">Total Eligible
                                                        Points</label>
                                                    <span class="d-block" v-if="scheme.isHerirachyScheme"
                                                          style="color: #fff; font-size: 22px; letter-spacing: 1.5px;">{{calculateEligiblePoints(scheme.SchemeEnrollments[0],true)}}</span>
                                                    <span class="d-block" v-else
                                                          style="color: #fff; font-size: 22px; letter-spacing: 1.5px;">{{calculateEligiblePoints(scheme.SchemeEnrollments[0],false)}}</span>
                                                </div>
                                                <div class="pt-3">
                                                    <label class="bankLabel" style="color: #d4d4d4;">Redeemable Points</label>
                                                    <span class="d-block"
                                                          style="color: #fff; font-size: 22px; letter-spacing: 1.5px;">{{calculateClosingPoints(scheme.SchemeEnrollments[0],scheme)}}</span>
                                                </div>
                                                <div class="pt-2">
                                                    <label class="bankLabel" style="color: #d4d4d4;">Total
                                                        Points</label>
                                                    <span class="d-block"
                                                          style="color: #fff; font-size: 22px; letter-spacing: 1.5px;">{{calculateTotalPoints(scheme.SchemeEnrollments[0],scheme)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="s-action-buttons w-100">
                                            <div class="d-flex ">
                                                <div @click="confirmJoinUnJoinAction(scheme, false)" class="s-actions px-3" style="width: auto" v-if="scheme.applicableOn !== 'RETAILSALES'">
                                                    <p class="text-white">Unjoin
                                                        <q-btn flat :loading="scheme.loading" v-if="scheme.loading"/>
                                                    </p>
                                                </div>
                                               <!-- <div @click="viewScheme(scheme)" class="s-actions mx-2 px-3" style="width: auto">
                                                    <p class="text-white">View details</p>
                                                </div> -->
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-panel>
            <q-tab-panel name="eligible">
                <div class="row " v-if="eligibleSchemes.length">

                    <div class="col-4 q-pa-md " v-for="scheme in eligibleSchemes">
                        <div class="card-bg">
                            <q-img :src="constants.base_url+scheme.backgroundImage" style="height: 100%;"></q-img>

                            <div class="card-details p-3">
                                <div class="position-relative" style="height: 100%;">
                                    <div class="card-content">
                                        <h5>{{scheme.name}}</h5>
                                    </div>

                                    <div class="mt-3 w-100" style="align-items: center; ">
                                        <div class="w-100 p-2">

                                            <div class="pr-2">
                                                <label class="bankLabel" style="color: #d4d4d4;">From</label>
                                                <span class="d-block"
                                                      style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{scheme.startTime|dateFilter}}</span>
                                            </div>
                                            <div class="pt-3">
                                                <label class="bankLabel" style="color: #d4d4d4;">To</label>
                                                <span class="d-block"
                                                      style="color: #fff; font-size: 14px; letter-spacing: 1.5px;">{{scheme.endTime|dateFilter}}</span>
                                            </div>
                                        </div>

                                        <div class="s-action-buttons w-100">
                                            <div class="d-flex">
                                                <div @click="confirmJoinUnJoinAction(scheme, true)" class="s-actions px-3 mx-2" style="width: auto" v-if="scheme.applicableOn !== 'RETAILSALES'">
                                                    <p class="text-white">Join
                                                        <q-btn flat :loading="scheme.loading" v-if="scheme.loading"/>
                                                    </p>
                                                </div>
                                                <!--<div @click="viewScheme(scheme)" class="s-actions mx-2 px-3" style="width: auto">
                                                    <p class="text-white">View details</p>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <img alt="" class="d-block mx-auto " src="../../assets/no_Data.png" style="width: 25%;">
                    <h6 class="text-center">No data available</h6>
                </div>
            </q-tab-panel>
        </q-tab-panels>

    </div>
</template>

<script>
import { SUBSCRIBE_ALL_SCHEMES1 } from './graphql/schemes'
import Constants from '../../Constants/Constant'
import moment from 'moment'
import {NetworkCommunicator} from "../../plugins/NetworkResourceHandler";
import Vue from 'vue';

  Array.prototype.contains = function (obj) {
    var i = this.length
    while (i--) {
      if (this[i] == obj) {
        return true
      }
    }
    return false
  }
  export default {
    name: 'P-Schemes',
    props: ['currentPartner'],
    apollo: {
        $subscribe: {
            Scheme: {
                query: SUBSCRIBE_ALL_SCHEMES1,
                skip() {return !this.currentPartner},
                variables() { return {
                    orgId: this.currentPartner.id,
                    startTime: moment().format('YYYY-MM-DD'),
                    endTime: moment().format('YYYY-MM-DD'),
                }},
                result({data}) {
                    let partnerType = this.currentPartner.partnerType;
                    this.jointSchemes = []; this.eligibleSchemes = [];
                    data.Scheme.forEach(s => {
                        if(s.SchemeEnrollments[0]?.isVerified && s.criteria?.[0]?.value.contains(partnerType)) this.jointSchemes.push(s);
                        else if (s.criteria?.[0]?.value.contains(partnerType)) this.eligibleSchemes.push(s)
                        /* (!curnt.SchemeEnrollments.length || !curnt.SchemeEnrollments[0].isVerified) */
                    })
                },
            },
        }
    },
    data () {
      return {
        constants: Constants,
        tab: 'joint',
        jointSchemes: [],
        eligibleSchemes: [],
        otp: '',
        otpId: '',
        verifyOtpDialog: false,
        user: JSON.parse(localStorage.getItem('user')),
        viewSchemeDialog: false,
        currentSchemeId: '',
      }
    },
    methods: {
      viewScheme (scheme) {
        this.currentSchemeId = scheme.id;
        this.viewSchemeDialog = true
      },
      confirmJoinUnJoinAction(scheme, isJoined){
        this.$q.dialog({
            title: `Confirm Scheme ${isJoined?'Join':'Unjoin'}`,
            message: `<div class="text-body1">Are you sure want to ${isJoined?'join':'unjoin'} a partner ${isJoined?'to':'from'} scheme <strong>'${scheme.name}'</strong> ?</div>`,
            html: true,
            cancel: true,
            persistent: true,
        }).onOk(() => this.joinUnJoinScheme(scheme, isJoined))
      },
      async joinUnJoinScheme (scheme, isJoined) {
        Vue.set(scheme, 'loading', true);
        let request = {
            schemeId: scheme.id,
            partnerId: [this.currentPartner.id],
            execId: this.user.id
        };
        let res = await NetworkCommunicator('POST', `${Constants.api_url}${isJoined?'joinSchemeBulkPartner':'unJoinSchemeBulkPartner'}`, false, request);
        if(res.flag) {
            Vue.set(scheme, 'loading', false);
            this.$q.notify(`Scheme ${isJoined?'joined':'unjoined'} successfully.`);
        } else {
            this.$q.notify(res.message);
            Vue.set(scheme, 'loading', false);
        }
      }
    },
  }
</script>

<style scoped>

</style>
